export const VIDEO_MSG_TYPES = {
  TEXT: 'text',
  SYSTEM: 'system',
  SEND_GIFT: 'send_gift',
}